import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDragLayer } from 'react-dnd';

function collect (monitor) {
  const item = monitor.getItem();

  return {
    id: item && item.id,
    name: item && item.name,
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging()
  };
}

function getItemStyles (currentOffset) {
  if (!currentOffset) {
    return {
      display: 'none'
    };
  }

  // http://www.paulirish.com/2012/why-moving-elements-with-translate-is-better-than-posabs-topleft/
  const x = currentOffset.x;
  const y = currentOffset.y;
  const transform = `translate(${x}px, ${y}px) rotate(4deg)`;

  return {
    pointerEvents: 'none',
    WebkitTransform: transform,
    transform: transform,
  };
}

function ItemPreview({
  id,
  name,
}) {
  const dragProps = useDragLayer(collect);

  const { isDragging, currentOffset } = dragProps;

  if (!isDragging) {
    return <div></div>;
  }

  return (
    <div
      className="employeebar__item-preview"
      style={getItemStyles(currentOffset)}
    >
      <FontAwesomeIcon icon="user" />
    </div>
  );
}

export default ItemPreview;



// WEBPACK FOOTER //
// ./src/components/EmployeeBar/EmployeePreview.js